<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
	<div class="flex flex-column flex-1 h-screen w-screen p-1">
		<!-- Fieldset Protocolo -->
		<R3FieldSet :title="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloDescricao.value">
			<R3InputNumber :ref="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloInput" class="flex-1"
				:data-finder-ref="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloDataFinderRef" icon="pi-search"
				button-data-finder-visible emit-enter @update:clear="onProtocoloReset"
				@keydown:enter="onProtocoloFind" />

			<!-- loadAllOnOpen: lista protocolos da empresa ao abrir (sem digitar) -->
			<R3DataFinder :ref="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloDataFinderRef"
				data-finder-name="DF_E1140" key-field="NUM_CARREG_PK_1140" title="Pesquisar Protocolo de Entrada"
				show-back-button
				:params="[
					{ name: 'EMPRESA_PF_1140', val: userStore.companyID!.toString() },
				]" :filter="filtrarTipoProtocolo" :load-all-on-open="true" :columns="[
					{ field: 'NUM_CARREG_PK_1140', header: 'Protocolo' },
					{ field: 'DESCR_AGRUP_1140', header: 'Descrição' },
				]" :on-dialog-result="onProtocoloSelecionado" order-by="DESC" />

			<!-- Radio buttons de nota fiscal, devolução, etc... -->
			<div v-if="radioButtonsProtocoloVisible" id="radio-buttons" class="flex ml-2 gap-1 w-8 align-items-center">
				<RadioButton v-model="protocoloSelecionadoRadioButton" name="protocolo" input-id="todosProtocolosRB"
					value="todos" />
				<label class="text-xl" for="todosProtocolosRB">Todos</label>

				<RadioButton v-model="protocoloSelecionadoRadioButton" name="protocolo" input-id="NFProtocoloRB"
					value="NF" />
				<label class="text-xl" for="NFProtocoloRB">NF</label>

				<RadioButton v-model="protocoloSelecionadoRadioButton" name="protocolo" input-id="devolucaoProtocoloRB"
					value="devolucao" />
				<label class="text-xl" for="devolucaoProtocoloRB">devolução</label>
			</div>
		</R3FieldSet>

		<!--	TabPanel controle geral -->
		<div v-if="tabPanelControleGeralVisible" id="tab-panel-controle-geral" class="flex flex-column flex-grow-1">
			<R3TabPanel :ref="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.conferenciaTabPanelRef
				" class="h-full w-full mt-1" :panels="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.panelTabs"
				:active-index="tabViewActiveIndex" @tab-change="onTabChange">
				<!-- Recebimento -->
				<template #recebimento>
					<!-- <ConferenciaDePlanilhaCegaRecebimentoTeste ref="conferenciaTabRecebimentoRef" /> -->
					<LazyRecebimentoTab ref="recebimentoTabRef"
						:parent="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR" />
				</template>

				<!-- Conferidas (E581) -->
				<template #conferidas>
					<LazyConferidas ref="conferidasTabRef"
						:parent="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR" />
				</template>

				<!-- Pendentes (E577_S581) -->
				<template #pendentes>
					<LazyPendentes ref="pendentesTabRef"
						:parent="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR"
						@selecionar-mercadoria="onSelecionarMercadoriaPendente" />
				</template>

				<!-- Tara -->
				<template #tara>
					<LazyTaraTab ref="taraTabRef" :parent="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR" />
				</template>

				<!-- Dados logísticos -->
				<template #dadosLogisticos>
					<LazyDadosLogisticos ref="dadosLogisticosTabRef"
						:parent="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR" />
				</template>

				<template #UMAPaleteConferido>
					<LazyUMAPaleteConferido ref="UMAPaleteConferidoRef"
						:parent="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR" />
				</template>

				<!-- Delphi ts_Impressora — import eager evita slot vazio se Lazy falhar -->
				<template #impressoraDirecionada>
					<ImpressoraDirecionadaTab
						:parent="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR" />
				</template>

				<!-- Calc lastro × camada (paridade coletor / botão LxC) -->
				<template #calcPesoVar>
					<CalcPesoVarTab
						:parent="fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR" />
				</template>
			</R3TabPanel>
		</div>
	</div>
</template>

<script lang="ts" setup>
	// {$R PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR/FPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.vue}
	import type {
		E1140Request,
		E1140Response,
		E1288NumSeriePendentesRequest,
		E1288NumSeriePendentesResponse,
		E581Request,
		E581Response,
	} from "@r3shared/types/WMS/MODU_COLETOR";
	import type { R3HTTPResponse } from "@r3shared/types/http";
	import type {
		E577_S581Request,
		E577_S581Response,
	} from "@r3shared/types/WMS/MODU_COLETOR/E577";
	import type {
		ProtocoloAcondicionamentoAntecipadoRequest,
		ProtocoloAcondicionamentoAntecipadoResponse,
		tipoLoteEntradaRequest,
		tipoLoteEntradaResponse,
	} from "@r3shared";
	import { FPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR } from "~/classes/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR/FPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR";
	import { useModuControleStore } from "~/store/MODU_CONTROLE/moduControle.store";
	import { RecebimentoTabClass } from "~/classes/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR/RecebimentoTabClass";
	import { TaraTabClass } from "~/classes/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR/TaraTabClass";
	import type {
		verificarTipoRecebimentoRequest,
		verificarTipoRecebimentoResponse,
	} from "@r3backend/src/modules/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR/app/dto/verificarTipoRecebimento.dto";
	import { UMAPaleteConferidoTabClass } from "~/classes/conferenciaDePlanilhaCega/UMAPaleteConferidoTab";
	import { DadosLogisticosTabClass } from "~/classes/conferenciaDePlanilhaCega/DadosLogisticosTab";
	import type RecebimentoTab from "~/components/conferenciaDePlanilhaCega/RecebimentoTab.vue";
	import type TaraTab from "~/components/conferenciaDePlanilhaCega/TaraTab.vue";
	import type DadosLogisticos from "~/components/conferenciaDePlanilhaCega/DadosLogisticos.vue";
	import type UMAPaleteConferido from "~/components/conferenciaDePlanilhaCega/UMAPaleteConferido/UMAPaleteConferido.vue";
	import ImpressoraDirecionadaTab from "~/components/conferenciaDePlanilhaCega/ImpressoraDirecionadaTab.vue";
	import CalcPesoVarTab from "~/components/conferenciaDePlanilhaCega/CalcPesoVarTab.vue";

	const moduControleStore = useModuControleStore();

	const fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR =
		new FPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR();

	const { $r3fetchdata } = useNuxtApp();
	// stores
	const conferenciaPlanilhaCegaStore = useConferenciaPlanilhaCegaStore();
	const diretrizesStore = useDiretrizesStore();
	const deviceStore = useDeviceStore();
	const userStore = useUserStore();
	const route = useRoute();

	const telaConferenciaSelecionada = computed(() =>
		resolverTelaConferenciaPlanilha(
			route.query.tela as string | string[] | null | undefined,
			userStore.menuSelected,
		),
	);

	// A página é mantida em cache; reaplicar o modo em toda troca B311/B315.
	watch(
		telaConferenciaSelecionada,
		(tela) => {
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.chamadoB315.value = tela === "B315";
		},
		{ immediate: true },
	);

	const recebimentoTabRef = ref<InstanceType<typeof RecebimentoTab> | null>(null);
	const taraTabRef = ref<InstanceType<typeof TaraTab> | null>(null);
	const dadosLogisticosTabRef = ref(null);
	const conferidasTabRef = ref(null);
	const pendentesTabRef = ref(null);
	const UMAPaleteConferidoRef = ref<InstanceType<
		typeof UMAPaleteConferido
	> | null>(null);

	// panel tabs
	// sincroniza as tabs que vão ser exibidas com base na visibilidade de cada tab
	export type Tabs =
		| "recebimento"
		| "conferidas"
		| "pendentes"
		| "tara"
		| "dadosLogisticos"
		| "impressoraDirecionada"
		| "calcPesoVar"
		| "UMAPaleteConferido";

	// const panelTabs = ref([
	// 	{ name: 'recebimento', header: 'Recebimento', visible: fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab.visible?.value ?? undefined },
	// 	{ name: 'tara', header: 'Tara', visible: fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.taraTab.visible?.value ?? undefined },
	// 	{ name: 'dadosLogisticos', header: 'Dados Logísticos', visible: fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.dadosLogisticosTab.visible?.value ?? undefined }, // ajuste conforme necessário
	// 	{ name: 'UMAPaleteConferido', header: 'U.M.A por Palete Conferido', visible: fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.UMAPaleteConferidoTab.visible?.value ?? undefined }
	// ]);

	// const panelTabs = ref([
	// 	{
	// 		name: "recebimento",
	// 		header: "Recebimento",
	// 		// ✅ Usar ?? true para garantir valor padrão
	// 		visible: computed(
	// 			() =>
	// 				fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab?.visible
	// 				?? true,
	// 		),
	// 	},
	// 	{
	// 		name: "tara",
	// 		header: "Tara",
	// 		visible: computed(
	// 			() =>
	// 				fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.taraTab?.visible ??
	// 				false,
	// 		),
	// 	},
	// 	{
	// 		name: "dadosLogisticos",
	// 		header: "Dados Logísticos",
	// 		visible: computed(
	// 			() =>
	// 				fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.dadosLogisticosTab?.visible
	// 				?? false,
	// 		),
	// 	},
	// 	{
	// 		name: "UMAPaleteConferido",
	// 		header: "U.M.A por Palete Conferido",
	// 		visible: computed(
	// 			() =>
	// 				fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.UMAPaleteConferidoTab
	// 					?.visible ?? false,
	// 		),
	// 	},
	// ]);

	// Faz o computed para filtrar as tabs visíveis e mostrar apenas elas no panel
	// const panels = computed(() =>
	// 	fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.panelTabs.value.filter((tab) => tab.visible)
	// );

	// watch dos visibles das tabs para atualizar o panelTabs
	// watch(
	// 	[
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab.visible,
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.taraTab.visible,
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.dadosLogisticosTab.visible,
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.UMAPaleteConferidoTab.visible,
	// 	],
	// 	() => {
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.panelTabs[0].visible =
	// 			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab.visible;
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.panelTabs[1].visible =
	// 			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.taraTab.visible;
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.panelTabs[2].visible =
	// 			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.dadosLogisticosTab.visible;
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.panelTabs[3].visible =
	// 			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.UMAPaleteConferidoTab.visible;
	// 	},
	// );

	// watch(
	// 	panels,
	// 	(newPanels) => {
	// 		const tabPanel =
	// 			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.conferenciaTabPanelRef.value;
	// 		if (!tabPanel) {
	// 			return;
	// 		}

	// 		tabPanel.panels = [...newPanels];
	// 	},
	// 	{ immediate: true, flush: "post" },
	// );

	const { msgDlg } = useMessageDlg();

	// Formulário de coletor: topbar com voltar (CollectorAppTopbar).
	definePageMeta({
		layout: "collector-option",
	});

	onBeforeMount(() => {
		useSetPageLayout(deviceStore.isMobile);

		//const recebimentoTabClass = new RecebimentoTabClass();

		//recebimentoTabClass.inputQtdTotalUnidade.enabled = true

		const taraTabClass = new TaraTabClass();
		const dadosLogisticosTabClass = new DadosLogisticosTabClass();
		const uMAPaleteConferidoTabClass = new UMAPaleteConferidoTabClass();

		/*fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab.value =
				recebimentoTabClass;*/
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.taraTab.value = taraTabClass;
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.dadosLogisticosTab.value =
			dadosLogisticosTabClass;
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.UMAPaleteConferidoTab.value =
			uMAPaleteConferidoTabClass;
	});

	// provide("recebimentoTab", recebimentoTab);
	// provide("UMAPaleteConferidoTab", UMAPaleteConferidoTab);
	// provide("taraTab", taraTab);
	// ✅ CORREÇÃO CRÍTICA: markRaw previne que o Vue converta em reactive()
	// Isso preserva o comportamento do autoRef e evita desembrulhamento de Refs
	provide(
		"FPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR",
		markRaw(fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR),
	);

	// -------------------------------

	// Template refs
	// const conferenciaTabPanelRef = ref<InstanceType<typeof R3TabPanel<controleGeralInfoPanels, controleGeralInfoHeaders>> | null>(null);
	// const conferenciaTabPanelRef = ref<InstanceType<typeof R3TabPanel> | null>(null);
	// const conferenciaTabRecebimentoRef = ref<InstanceType<typeof Recebimento> | null>(null);

	// -------------------------------

	// -------------------------------
	// TabView
	const tabViewActiveIndex = ref(0);

	function onTabChange(tab: { index: number; originalEvent: PointerEvent }) {
		tabViewActiveIndex.value = tab.index;
		const panels = fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.panelTabs.value
			?? fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.panelTabs;
		const panelList = Array.isArray(panels) ? panels : [];
		const visible = panelList.filter((p: { visible?: boolean }) => p.visible !== false);
		const current = visible[tab.index] as { name?: Tabs } | undefined;
		if (current?.name) {
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.activeTab.value = current.name;
			// Atualiza listas ao entrar nas abas de grade
			if (current.name === "conferidas") {
				void checarItensConferidos();
				(conferidasTabRef.value as { recarregar?: () => void } | null)?.recarregar?.();
			}
			if (current.name === "pendentes") {
				void checarItensNaoConferidos();
				(pendentesTabRef.value as { recarregar?: () => void } | null)?.recarregar?.();
			}
		}
	}

	// -------------------------------

	// -------------------------------
	// Protocolo

	function filtrarTipoProtocolo(rows: Array<object>) {
		const tipoProtocolo = protocoloSelecionadoRadioButton.value;

		return rows.filter((row) => {
			const r = row as E1140Response;

			if (tipoProtocolo === "todos") {
				return true;
			} else if (tipoProtocolo === "NF") {
				// Filtra apenas notas fiscais
				return r.TIPO_LOTE === "C";
			} else if (tipoProtocolo === "devolucao") {
				// Filtra apenas devoluções
				return r.TIPO_LOTE === "G";
			}
			return true;
		});
	}


	//const protocolo = ref<number | null>(fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo?.NUM_CARREG_PK_1140 || null);
	// const protocolo = ref(fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo?.NUM_CARREG_PK_1140);
	// const protocolo = computed({
	// 	get: () => fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloRef.value?.inputValue,
	// 	set: (value) => {
	// 		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloRef.value!.inputValue = value;
	// 	}
	// });

	// const protocoloDataFinderRef = useTemplateRef("protocoloDataFinderRef");

	// const inputProcoloRef = useTemplateRef("inputProcoloRef");

	function focarInputProtocolo() {
		nextTick(() => {
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloInput.setFocus();
			//inputProcoloRef.value?.setFocus({ limparCampo: false });
		});
	}

	const protocoloFieldsetLabel = ref<string>("Protocolo :");

	async function onProtocoloSelecionado(protocoloSelecionado: E1140Response) {
		if (!protocoloSelecionado) {
			return;
		}

		// Grava protocolo antes das checagens (necessário para as APIs)
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloInput.inputValue =
			protocoloSelecionado.NUM_CARREG_PK_1140;
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo.value =
			protocoloSelecionado;
		conferenciaPlanilhaCegaStore.setProtocolo(protocoloSelecionado);
		// Delphi: "Protocolo No: 00028417" (zeros à esquerda)
		const protFmt = String(protocoloSelecionado.NUM_CARREG_PK_1140 ?? "").padStart(8, "0");
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloDescricao.value =
			`Protocolo No: ${protFmt} - ${protocoloSelecionado.DESCR_AGRUP_1140}`;

		// Delphi Recebimento_Iniciar: se há série pendente, MsgDlg + PreparaNumSerie + Exit
		// (não segue para conferência livre de mercadoria).
		const bloqueadoPorSerie = await verificarPendenciaLancamentoNumSerie();
		if (bloqueadoPorSerie) {
			await bloquearEntradaConferencia();
			return;
		}

		// B315: se não puder atribuir tipo de antecipação (ex.: endereços reservados),
		// mostra o aviso e NÃO libera a tela de conferência.
		const bloqueadoPorTipoRecebimento = await verificarTipoRecebimento();
		if (bloqueadoPorTipoRecebimento) {
			await bloquearEntradaConferencia();
			return;
		}

		tabPanelControleGeralVisible.value = true;
		radioButtonsProtocoloVisible.value = false;

		await iniciarRecebimento();

		// Verificar acondicionamento antecipado
		await definirAcondicionamentoAntecipado();
		await obterTipoLoteEntrada();
		verificarLoteDevolucao();
	}

	/** Mantém o operador no protocolo — não abre abas de conferência. */
	async function bloquearEntradaConferencia() {
		tabPanelControleGeralVisible.value = false;
		radioButtonsProtocoloVisible.value = true;
		await fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloInput.setFocus();
	}


	/**
	 * Enter no campo Protocolo (Delphi Edit_Protocolo ClickKey = 13).
	 * Abre a lista de protocolos em aberto (DF_E1140) para o usuário escolher —
	 * NÃO localiza/seleciona sozinho e não inicia a conferência.
	 * A lupa abre o mesmo DataFinder (rightBtnclick → show).
	 */
	function onProtocoloFind() {
		const dfRef =
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloDataFinderRef;
		const df =
			(dfRef as { value?: { show?: () => void } })?.value
			?? (dfRef as { show?: () => void });

		if (!df || typeof df.show !== "function") {
			console.error("DataFinder de protocolo indisponível");
			return;
		}

		df.show();
	}


	function onProtocoloReset() {
		radioButtonsProtocoloVisible.value = true;
		tabPanelControleGeralVisible.value = false;
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloInput.inputValue = null;
		conferenciaPlanilhaCegaStore.setProtocolo(null);
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloDescricao.value = "Protocolo :";
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloInput.setFocus();
		// focarInputProtocolo()
	}

	// Radio buttons
	const radioButtonsProtocoloVisible = ref(true);

	const protocoloSelecionadoRadioButton = ref<
		"todos" | "NF" | "devolucao" | undefined
	>("todos");

	/**
	 * B315: valida/ajusta tipo de acondicionamento antecipado do protocolo.
	 * @returns true se deve bloquear a entrada na conferência.
	 */
	async function verificarTipoRecebimento(): Promise<boolean> {
		if (userStore.menuSelected !== "B315") {
			return false;
		}

		const protocoloSelecionado =
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo.value
				?.NUM_CARREG_PK_1140;
		if (!protocoloSelecionado) {
			return false;
		}

		try {
			const tipoRecebimento = await $r3fetchdata.post<
				R3HTTPResponse<verificarTipoRecebimentoResponse | string>,
				verificarTipoRecebimentoRequest
			>(
				"/api/proc_digitacao_planilha_conferencia_coletor/verificartiporecebimento",
				{
					empresa: userStore.companyID!,
					protocolo: protocoloSelecionado,
				},
			);

			// Kernel envelopa em { success, response }; aceitar os dois formatos.
			const envelope = tipoRecebimento as R3HTTPResponse<
				verificarTipoRecebimentoResponse | string
			> | null;
			const inner =
				envelope &&
				typeof envelope === "object" &&
				"response" in envelope &&
				envelope.response &&
				typeof envelope.response === "object" &&
				"success" in (envelope.response as object)
					? (envelope.response as R3HTTPResponse<
							verificarTipoRecebimentoResponse | string
						>)
					: envelope;

			if (inner && inner.success === false) {
				const mensagem =
					typeof inner.response === "string"
						? inner.response
						: "Não foi possível validar o tipo de recebimento do protocolo.";
				await msgDlg("Verificação", "atencao", mensagem, ["OK"]);
				return true;
			}
		} catch (e) {
			console.error("verificarTipoRecebimento:", e);
			await msgDlg(
				"Verificação",
				"atencao",
				"Erro ao validar o tipo de recebimento do protocolo.",
				["OK"],
			);
			return true;
		}

		return false;
	}

	// ---------------------------------

	// ----------------------------------
	// Tab panel controle geral
	const tabPanelControleGeralVisible = ref(false);

	// ----------------------------------

	// ----------------------------------
	// Recebimento
	const mercadoria = ref<number | null>();

	async function iniciarRecebimento() {
		mercadoria.value = null;
		limparDadosMercadoria();

		// Delphi Recebimento_Iniciar: Tara some; D.Logist só com mercadoria.
		// Impressora Direcionada e Calc peso var permanecem disponíveis.
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("recebimento", true);
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("tara", false);
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("dadosLogisticos", false);
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("impressoraDirecionada", true);
		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("calcPesoVar", true);

		const isB315 = fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.chamadoB315.value;

		// B315 (foto Delphi): abas fixas
		// Recebimento | Conferidas | Pendentes | U.M.A por Palete Conferido
		if (isB315) {
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("recebimento", true);
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("conferidas", true);
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("pendentes", true);
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible(
				"UMAPaleteConferido",
				true,
			);
		}
		else {
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible(
				"UMAPaleteConferido",
				false,
			);
		}

		await checarItensConferidos();
		await checarItensNaoConferidos();

		// B315: reafirma as 4 abas (checar* pode esconder se a lista vier vazia)
		if (isB315) {
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("conferidas", true);
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("pendentes", true);
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible(
				"UMAPaleteConferido",
				true,
			);
		}

		fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.conferenciaTabPanelRef.value!.setTabFocusByName(
			"recebimento",
		);
	}

	async function checarItensConferidos() {
		const prot =
			conferenciaPlanilhaCegaStore.protocolo
			?? fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo.value;
		const empresa = Number(prot?.EMPRESA_PF_1140);
		const numCarreg = Number(prot?.NUM_CARREG_PK_1140);
		if (!Number.isFinite(empresa) || !Number.isFinite(numCarreg)) return;

		try {
			const itensConferidos = await $r3fetchdata.get<
				R3HTTPResponse<Array<E581Response>>,
				E581Request
			>("/api/modu_coletor/itensconferidos", {
				params: {
					EMPRESA_PF_581: empresa,
					NUM_CARREG_PK_581: numCarreg,
				},
			});

			const lista = Array.isArray(itensConferidos)
				? itensConferidos
				: Array.isArray(itensConferidos?.response)
					? itensConferidos.response
					: [];
			conferenciaPlanilhaCegaStore.setItensConferidos(lista);
			// Delphi: tsConferidas.TabVisible := not IsEmpty
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible(
				"conferidas",
				lista.length > 0,
			);
		} catch (e) {
			console.error("checarItensConferidos:", e);
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("conferidas", false);
		}
	}

	async function checarItensNaoConferidos() {
		const prot =
			conferenciaPlanilhaCegaStore.protocolo
			?? fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo.value;
		const empresa = Number(prot?.EMPRESA_PF_1140);
		const numCarreg = Number(prot?.NUM_CARREG_PK_1140);
		if (!Number.isFinite(empresa) || !Number.isFinite(numCarreg)) return;

		try {
			const itensPendenteConferencia = await $r3fetchdata.get<
				R3HTTPResponse<Array<E577_S581Response>>,
				E577_S581Request
			>("/api/modu_coletor/itensnaoconferidos", {
				params: {
					EMPRESA_PF_577: empresa,
					NUM_CARREG_577: numCarreg,
				},
			});

			const lista = Array.isArray(itensPendenteConferencia)
				? itensPendenteConferencia
				: Array.isArray(itensPendenteConferencia?.response)
					? itensPendenteConferencia.response
					: [];
			conferenciaPlanilhaCegaStore.setItensPendentes(lista);
			// Delphi: tsPendentes.TabVisible := not IsEmpty
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible(
				"pendentes",
				lista.length > 0,
			);
		} catch (e) {
			console.error("checarItensNaoConferidos:", e);
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.setPanelTabVisible("pendentes", false);
		}
	}

	/** Preenche mercadoria no Recebimento a partir da aba Pendentes */
	function onSelecionarMercadoriaPendente(mercadoriaId: number) {
		const tab = fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab;
		if (tab?.inputMercadoria) {
			tab.inputMercadoria.inputValue = mercadoriaId;
		}
	}

	function limparDadosMercadoria() {
		// conferenciaPlanilhaCegaStore.adicionarInfoPanel({
		// 	panel: "conferidas",
		// 	header: "Conferidas"
		// });
		// conferenciaPlanilhaCegaStore.removerInfoPanel({
		// 	panel: "dadosLogisticos",
		// 	header: "D.Logísticos"
		// });

		// Desabilita o label de validade picking sempre que os dados da mercadoria são limpos globalmente
		if (fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab) {
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab.labelValidadePicking.visible = false;
		}
	}

	/**
	 * Verifica pendência de digitação de número de série (E1288).
	 * @returns true se deve bloquear a entrada na conferência (há pendência).
	 * Delphi: MsgDlg + PreparaNumSerie + Exit em Recebimento_Iniciar.
	 */
	async function verificarPendenciaLancamentoNumSerie(): Promise<boolean> {
		const prot =
			conferenciaPlanilhaCegaStore.protocolo
			?? fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo.value;
		const empresa = Number(prot?.EMPRESA_PF_1140 ?? userStore.companyID);
		const numCarreg = Number(prot?.NUM_CARREG_PK_1140);
		const usuario = Number(userStore.userID);

		if (!Number.isFinite(empresa) || !Number.isFinite(numCarreg) || !Number.isFinite(usuario)) {
			return false;
		}

		try {
			const pendenciasLancamentoNumeroDeSerie = await $r3fetchdata.get<
				R3HTTPResponse<E1288NumSeriePendentesResponse[] | []>,
				E1288NumSeriePendentesRequest
			>("/api/modu_coletor/pendenciaslancamentonumerodeserie", {
				params: {
					EMPRESA_PF_580: empresa,
					NUM_CARREG_PK_580: numCarreg,
					USU_BIPOU_580: usuario,
				},
			});

			const lista = Array.isArray(pendenciasLancamentoNumeroDeSerie)
				? pendenciasLancamentoNumeroDeSerie
				: Array.isArray(pendenciasLancamentoNumeroDeSerie?.response)
					? pendenciasLancamentoNumeroDeSerie.response
					: [];

			if (lista.length > 0) {
				const { msgDlg } = useMessageDlg();
				await msgDlg(
					"Número de série",
					"atencao",
					"Existem Números de Série Pendentes de Digitação!",
					["OK"],
					false,
				);
				// Aba Núm. Série ainda não migrada: bloqueia conferência (não deixa entrar).
				// Quando PreparaNumSerie existir, redirecionar para a aba em vez de bloquear.
				// preparaNumeroDeSerie(lista[0]);
				return true;
			}
		} catch (e) {
			console.error("verificarPendenciaLancamentoNumSerie:", e);
		}

		return false;
	}

	async function preparaNumeroDeSerie(_pendencia?: E1288NumSeriePendentesResponse) {
		// TODO: migrar tsSerie / PreparaNumSerie do Delphi (foco no campo e grid de série)
	}

	// ----------------------------------
	// Se for lote de devolução, encaminha as mercadorias para o picking
	function verificarLoteDevolucao() {
		// fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab
		// 		.pickingAcondicionadoPaletizacaoDropdown.visible = true;
		// if (diretrizesStore.getDiretriz("E212")?.SN_ARMAZENA_DEVOLUC_PULMAO_212 === "N") {
		if (
			conferenciaPlanilhaCegaStore.tipoLoteEntrada === "G" ||
			conferenciaPlanilhaCegaStore.tipoLoteEntrada === "H"
		) {
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab.pickingAcondicionadoPaletizacaoDropdown.inputValue =
				"S";
			conferenciaPlanilhaCegaStore.setPickingAcondicionadoValue("S");
			fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.recebimentoTab.pickingAcondicionadoPaletizacaoDropdown.enabled =
				false;
			conferenciaPlanilhaCegaStore.setPickingAcondicionadoEnabled(false);
			conferenciaPlanilhaCegaStore.setBtnLastroCamadaVisible(false);
		}
		// }
	}

	// ----------------------------------
	// cabeçalho da nota importada

	async function obterTipoLoteEntrada() {
		// TODO implementar a obtenção do tipo de cabeçalho da nota importada
		const loteEntrada = await $r3fetchdata.get<
			R3HTTPResponse<tipoLoteEntradaResponse>,
			tipoLoteEntradaRequest
		>("/api/proc_digitacao_planilha_conferencia_coletor/tipoloteentrada", {
			params: {
				EMPRESA: userStore.companyID!,
				PROTOCOLO:
					fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo.value!
						.NUM_CARREG_PK_1140,
			},
		});
		conferenciaPlanilhaCegaStore.setTipoLoteEntrada(
			loteEntrada.response!.TIPO_LT_444,
		);
		conferenciaPlanilhaCegaStore.setFornecedorLote(
			loteEntrada.response!.ID_EMISSOR_444,
		);
	}

	// ----------------------------------
	// Acondicionamento antecipado — LabelAcondAntecip do Delphi ("3-Antecipa Palete…")
	async function definirAcondicionamentoAntecipado() {
		if (!fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo) return;

		const acondAntecipado = await $r3fetchdata.get<
			R3HTTPResponse<
				| ProtocoloAcondicionamentoAntecipadoResponse
				| ProtocoloAcondicionamentoAntecipadoResponse[]
			>,
			ProtocoloAcondicionamentoAntecipadoRequest
		>("/api/twms/protocoloacondicionado", {
			params: {
				EMPRESA: userStore.companyID!,
				PROTOCOLO:
					fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocolo.value
						?.NUM_CARREG_PK_1140 ?? 0,
			},
		});

		// Kernel: { success, response }. Aceitar corpo direto ou envelopado.
		const envelope = acondAntecipado as R3HTTPResponse<
			| ProtocoloAcondicionamentoAntecipadoResponse
			| ProtocoloAcondicionamentoAntecipadoResponse[]
		> | null;
		const inner =
			envelope
			&& typeof envelope === "object"
			&& "response" in envelope
			&& envelope.response
			&& typeof envelope.response === "object"
			&& "success" in (envelope.response as object)
				? (envelope.response as R3HTTPResponse<
						| ProtocoloAcondicionamentoAntecipadoResponse
						| ProtocoloAcondicionamentoAntecipadoResponse[]
					>)
				: envelope;

		const bruto = inner?.response;
		const item = Array.isArray(bruto) ? bruto[0] : bruto;

		if (inner?.success && item && typeof item === "object") {
			conferenciaPlanilhaCegaStore.setAcondicionamentoAntecipado(
				item as ProtocoloAcondicionamentoAntecipadoResponse,
			);
		}
		else {
			conferenciaPlanilhaCegaStore.setAcondicionamentoAntecipado(null);
		}
	}

	// ----------------------------------
	// LifeCycle
	const loading = ref(true);
	onMounted(async () => {
		loading.value = false;
		console.log(userStore.menuSelected);
		await diretrizesStore.atualizarDiretrizes(["E212", "E211", "E202", "E215", "E226"]);
		// const diretrizes = $r3fetchdata.get<
		// 	AtualizarDiretrizesResponse, AtualizarDiretrizesRequest
		// >("/api/modu_diretrizes/atualizardiretrizes", {
		// 	params: {
		// 		diretrizes: ["E212", "E211", "E202", "E215", "E226"],
		// 		Empresa: 900
		// 	}
		// });
		//

		// conferenciaPlanilhaCegaStore.adicionarInfoPanel({
		// 	header: "Tara",
		// 	panel: "tara"
		// })

		// focarInputProtocolo();

		// ajustar campos de logistica semi automatica
		if (
			diretrizesStore.getDiretriz("E212")?.SN_ACOND_SEMI_AUTOMATICO_212 === "S" &&
			diretrizesStore.getDiretriz("E202")?.TIPO_DEPOSIT_202 === "C"
		) {
			conferenciaPlanilhaCegaStore.setPanelSemiAutomaticoVisible(true);
		}

		// TODO verificar se o usuário tem acesso aos dados logísticos de mercadoria (B11)

		// TODO carregar listas de impressoras

		await fPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR.protocoloInput.setFocus();
		console.debug("fPROC:", FPROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR);
	});

	// ----------------------------------
	// Aba de tara

	// unidade
	const labelTaraUnidadeFieldset = ref("Unidade - Peso de embalagem em kg");

	// label
	provide("labelTaraUnidadeFieldset", labelTaraUnidadeFieldset);

	// caixa
	const qtdTaraCaixa = ref<number | null>(null);
	const qtdTaraCaixaEnabled = ref(true);
	provide("qtdTaraCaixa", qtdTaraCaixa);
	provide("setQtdTaraCaixa", (value: number) => {
		qtdTaraCaixa.value = value;
	});

	provide("qtdTaraCaixaEnabled", qtdTaraCaixaEnabled);

	// palete
	const qtdTaraPalete = ref<number | null>(null);
	const qtdTaraPaleteEnabled = ref(true);
	provide("qtdTaraPalete", qtdTaraPalete);
	provide("setQtdTaraPalete", (value: number) => {
		qtdTaraPalete.value = value;
	});

	provide("qtdTaraPaleteEnabled", qtdTaraPaleteEnabled);

	// ----------------------------------
</script>

<style lang="scss">
	.p-tabview .p-tabview-panels {
		padding-left: 0px !important;
		padding-right: 0px !important;
	}
</style>
